import script from "./CmsTexts.vue?vue&type=script&setup=true&lang=js"
export * from "./CmsTexts.vue?vue&type=script&setup=true&lang=js"

import "./CmsTexts.vue?vue&type=style&index=0&id=6ff2af86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff2af86"]])

export default __exports__